// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 5px;
  background-color: rgba(122, 122, 122, 0.692);
}

::-webkit-scrollbar-thumb {
  border-radius: 7px;
  background-color: rgba(44, 50, 73, 0.692);
  box-shadow: 0 0 1px rgba(26, 31, 48, 0.692);
}

.mainDiv {
  padding-top: 65px;
}

.tableHeader {
  background-color: aquamarine;
}

.loadingDataDiv {
  background-color: transparent;
  position: absolute;
  width: 100%;
  min-height: 500px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.loadingDataDiv img {
  width: 100px;
}

.clientCreateButtonDiv {
  width: 100%;
  position: relative;
  height: 60px;
  display: flex;
  align-items: center;
}
.clientCreateButtonDiv .clientCreateButton {
  margin-left: calc(100vw - 120px);
  font-size: 14px;
}

.getMain {
  overflow-x: scroll;
}
.getMain div.MuiPaper-rounded {
  min-height: 100vh;
  width: 2800px;
}
.getMain .tableBody {
  border-radius: 20px;
}
.getMain .tableBody .dataRow {
  background-color: hsla(0, 0%, 100%, 0.04);
}
.getMain .tableBody .dataRow .select-box .gender-select div {
  padding-top: 5px;
  padding-bottom: 5px;
}
.getMain .tableBody .dataRow .refferal-select fieldset span {
  display: none;
}
.getMain .tableBody .dataRow .select label {
  color: red;
}
.getMain .tableBody .dataRow td {
  padding: 0;
}
.getMain .tableBody .dataRow td h1 {
  margin-left: 10px;
  padding: 0 10px;
  padding-right: 17px;
}
.getMain .tableBody .dataRow td h3 {
  padding-left: 16px;
  font-size: 14px;
  display: flex;
  padding-right: 17px;
}
.getMain .tableBody .dataRow td h3 .summary-input {
  background-color: transparent;
  color: white;
  border: 0;
  outline: none;
  border-bottom: 1px solid transparent;
  width: 65px;
  text-align: center;
}
.getMain .tableBody .dataRow td h3 .summary-input::-webkit-outer-spin-button,
.getMain .tableBody .dataRow td h3 .summary-input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.getMain .tableBody .dataRow td h3 .summary-input:focus {
  background-color: transparent;
  color: white;
  border: 0;
  border-bottom: 1px solid white;
}
.getMain .tableBody .dataRow td div label {
  top: -11px;
  font-size: 14px;
}
.getMain .tableBody .dataRow td div label.MuiFormLabel-filled {
  top: 4px;
  left: 4px;
  font-size: 12px;
}
.getMain .tableBody .dataRow td div label.Mui-focused {
  top: 4px;
  left: 4px;
  font-size: 12px;
}
.getMain .tableBody .dataRow td div input {
  padding-top: 5px;
  padding-bottom: 5px;
  font-size: 14px;
}
.getMain .tableBody .dataRow td div fieldset {
  border-radius: 8px;
}
.getMain .tableBody .dataRow .datepicker-box {
  width: 130px;
  max-width: 130px;
  padding-right: 17px;
  padding-top: 5px;
}
.getMain .tableBody .dataRow .datepicker-box * {
  max-width: 130px;
}
.getMain .tableBody .dataRow .datepicker-box .MuiInputBase-root {
  overflow: hidden;
  transform: translateY(-3px);
}
.getMain .tableBody .dataRow .dogovor-box {
  width: 120px;
  max-width: 120px;
  padding-right: 17px;
}
.getMain .tableBody .dataRow .dogovor-box * {
  max-width: 120px;
}
.getMain .tableBody .dataRow .dogovor-box-law {
  width: 195px;
  max-width: 195px;
}
.getMain .tableBody .dataRow .dogovor-box-law * {
  max-width: 195px;
}
.getMain .tableBody .dataRow .fio-box {
  width: 350px;
  padding-right: 17px;
}
.getMain .tableBody .dataRow .fio-box .fio-input {
  width: 100%;
}
.getMain .tableBody .dataRow .company-box {
  width: 220px;
  padding-right: 17px;
}
.getMain .tableBody .dataRow .company-box .fio-input {
  width: 100%;
}
.getMain .tableBody .dataRow .phone-box {
  width: 170px;
  max-width: 170px;
  padding-right: 17px;
}
.getMain .tableBody .dataRow .phone-box * {
  max-width: 170px;
}
.getMain .tableBody .dataRow .email-box {
  width: 290px;
  max-width: 290px;
  padding-right: 17px;
}
.getMain .tableBody .dataRow .email-box * {
  max-width: 290px;
}
.getMain .tableBody .dataRow .email-box .email-input {
  width: 100%;
}
.getMain .tableBody .dataRow .gender-box {
  width: 100px;
  max-width: 100px;
}
.getMain .tableBody .dataRow .gender-box * {
  max-width: 100px;
}
.getMain .tableBody .dataRow .adress-box {
  width: 450px;
  max-width: 450px;
  padding: 0 17px;
}
.getMain .tableBody .dataRow .adress-box * {
  max-width: 450px;
}
.getMain .tableBody .dataRow .adress-box .adress-basic {
  width: 100%;
}
.getMain .tableBody .dataRow .adress-box-law {
  padding-left: 0;
}
.getMain .tableBody .dataRow .select-box {
  width: 190px;
  max-width: 190px;
  padding-right: 17px;
}
.getMain .tableBody .dataRow .select-box * {
  max-width: 190px;
}
.getMain .tableBody .dataRow .select-box .adress-basic {
  width: 100%;
}
.getMain .tableBody .dataRow .textarea-box {
  width: 210px;
  max-width: 210px;
  padding-right: 17px;
}
.getMain .tableBody .dataRow .textarea-box * {
  max-width: 210px;
}
.getMain .tableBody .dataRow .textarea-box .adress-basic {
  width: 100%;
}
.getMain .tableBody .dataRow .datepicker-box-create {
  width: 200px;
  max-width: 200px;
  padding-right: 17px;
  padding-top: 0;
}
.getMain .tableBody .dataRow .datepicker-box-create .datetimepicker {
  height: 35px;
  padding-top: 0;
  min-width: 20px;
  margin-top: -4px;
}
.getMain .tableBody .dataRow .datepicker-box-create * {
  max-width: 200px;
}
.getMain .tableBody .dataRow .datepicker-box-create input.Mui-disabled {
  color: #fff;
  -webkit-text-fill-color: #fff;
}
.getMain .tableBody .dataRow textarea {
  width: 200px;
  height: 30px;
  min-width: 200px;
  max-width: 300px;
  min-height: 30px;
  max-height: 700px;
  box-sizing: border-box;
  margin-top: 5px;
  border-radius: 8px;
  border: 1px solid gray;
  background-color: transparent;
  color: white;
  padding: 5px;
  padding-left: 15px;
}
.getMain .tableBody .dataRow:hover td {
  background-color: hsla(0, 0%, 100%, 0.1);
}
.getMain .tableBody .tableCell {
  background-color: aquamarine;
}

body .skiny div label {
  top: -11px !important;
  font-size: 14px !important;
}
body .skiny div label.MuiFormLabel-filled {
  top: 4px !important;
  left: 4px !important;
  font-size: 12px !important;
}
body .skiny div label.Mui-focused {
  top: 4px !important;
  left: 4px !important;
  font-size: 12px !important;
}
body .skiny div input {
  padding-top: 5px !important;
  padding-bottom: 5px !important;
  font-size: 14px !important;
}
body .skiny div fieldset {
  border-radius: 8px !important;
}
body .skiny div .datetimepicker label {
  top: -14px !important;
}
body .skiny .select {
  height: 30px !important;
}
body .skinyTime div label {
  top: 2px !important;
  font-size: 14px !important;
}

.dataRowCreate td {
  padding-top: 5px;
  padding-bottom: 5px;
  padding-left: 0;
}
.dataRowCreate td:first-child {
  padding-left: 20px;
}

.getMainLaw div.MuiPaper-rounded {
  width: 2700px;
}

.getMainCreate::-webkit-scrollbar {
  height: 5px;
}

.getMainCreate {
  overflow-x: scroll;
}
.getMainCreate div.MuiPaper-rounded {
  width: 2350px;
}
.getMainCreate .mainTableCreate .datepicker-box-create {
  width: 200px;
  max-width: 200px;
  padding-right: 17px;
}
.getMainCreate .mainTableCreate .datepicker-box-create div.MuiTextField-root {
  min-width: 20px;
}
.getMainCreate .mainTableCreate .datepicker-box-create * {
  max-width: 200px;
}
.getMainCreate .mainTableCreate .datepicker-box-create .MuiInputBase-root {
  overflow: hidden;
  transform: translateY(-3px);
}
.getMainCreate .mainTableCreate .tableBody .dataRow td div fieldset {
  border-radius: 10px;
}

.MuiInputBase-formControl fieldset {
  border-radius: 10px;
}

.refferal-select {
  width: 170px;
}
.refferal-select .MuiSelect-select {
  font-size: 14px !important;
}

.location-select {
  width: 170px;
}

.gender-select {
  width: 100px;
}

.select-box {
  height: 30px;
}
.select-box label {
  margin-bottom: -25px;
  transform: translateY(-20px) translateX(10px);
}
.select-box .MuiOutlinedInput-input.Mui-disabled {
  color: #fff;
  -webkit-text-fill-color: #fff;
}

.gender-select .MuiOutlinedInput-input.Mui-disabled {
  color: #fff;
  -webkit-text-fill-color: #fff;
}

.AccordionDetails {
  padding: 0 !important;
}

.accordionHeaders {
  margin-bottom: 0;
  margin-top: 10px;
  margin-left: 15px;
}

.filtrDiv {
  padding: 10px 15px;
  padding-top: 5px;
  display: flex;
  align-items: center;
  gap: 30px;
  box-sizing: border-box;
}
.filtrDiv .searchInput {
  margin-top: 8px;
}
.filtrDiv .createClientTypograpyh {
  border: 2px solid rgb(26, 213, 26);
  border-radius: 10px;
  padding: 10px 15px;
  cursor: pointer;
  margin-top: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  max-height: 43px;
  height: 43px;
  -webkit-user-select: none;
          user-select: none;
}
.filtrDiv .createTaskTypograpyh {
  margin-top: 0;
}
.filtrDiv .statisticButton {
  border: 1px solid #525252;
  border-radius: 10px;
  padding: 10px 15px;
  cursor: pointer;
  margin-top: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  max-height: 41px;
  -webkit-user-select: none;
          user-select: none;
}
.filtrDiv .statisticButton:hover {
  border: 1px solid #fff;
  color: #fff !important;
}
.filtrDiv .datetimepicker input,
.filtrDiv .searchInput input {
  padding: 10px 20px;
}
.filtrDiv .datetimepicker label,
.filtrDiv .searchInput label {
  top: -5px;
  font-size: 14px;
}
.filtrDiv .datetimepicker label.MuiFormLabel-filled,
.filtrDiv .searchInput label.MuiFormLabel-filled {
  top: 4px;
  left: 4px;
  font-size: 12px;
}
.filtrDiv .datetimepicker label.Mui-focused,
.filtrDiv .searchInput label.Mui-focused {
  top: 4px;
  left: 4px;
  font-size: 12px;
}
.filtrDiv .datetimepicker {
  height: 40px;
  max-width: 100px;
}
.filtrDiv .dateFromTo {
  min-width: 190px !important;
}
.filtrDiv .dateFromTo input {
  color: transparent !important;
}
.filtrDiv .dateValue input {
  color: white !important;
}
.filtrDiv p {
  color: gray !important;
}

.statisticDiv {
  padding: 15px;
  padding-top: 0px;
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}
.statisticDiv .statBlock {
  min-width: 100px;
  background-color: rgba(255, 255, 255, 0.07);
  padding: 20px;
  border-radius: 10px;
}
.statisticDiv .statBlock h4 {
  margin-bottom: 10px;
  color: #1976d2;
  margin-top: 0;
}
.statisticDiv .statBlock p {
  margin: 5px 0;
  font-size: 14px;
}

@media (max-width: 1750px) {
  .filtrDiv {
    flex-wrap: wrap;
  }
  .filtrDiv .datetimepicker {
    overflow: hidden;
    height: 43px;
  }
  .filtrDiv .datetimepicker * {
    overflow: hidden;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/main/main.scss"],"names":[],"mappings":"AAAA;EACI,wBAAA;EACA,UAAA;EACA,4CAAA;AACJ;;AAEA;EACI,kBAAA;EACA,yCAAA;EACA,2CAAA;AACJ;;AAGA;EACI,iBAAA;AAAJ;;AAMA;EACI,4BAAA;AAHJ;;AAMA;EACI,6BAAA;EACA,kBAAA;EACA,WAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAHJ;AAKI;EACI,YAAA;AAHR;;AAOA;EACI,WAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;AAJJ;AAMI;EACI,gCAAA;EACA,eAAA;AAJR;;AASA;EACI,kBAAA;AANJ;AAQI;EACI,iBAAA;EACA,aAAA;AANR;AAUI;EACI,mBAAA;AARR;AAYQ;EACI,yCAAA;AAVZ;AAcoB;EACI,gBAAA;EACA,mBAAA;AAZxB;AAmBoB;EACI,aAAA;AAjBxB;AAyBgB;EACI,UAAA;AAvBpB;AA2BY;EACI,UAAA;AAzBhB;AA4BgB;EACI,iBAAA;EACA,eAAA;EACA,mBAnFT;AAyDX;AA6BgB;EACI,kBAAA;EACA,eAAA;EACA,aAAA;EACA,mBA1FT;AA+DX;AA6BoB;EACI,6BAAA;EACA,YAAA;EACA,SAAA;EACA,aAAA;EACA,oCAAA;EACA,WAAA;EACA,kBAAA;AA3BxB;AA8BoB;;EAEI,wBAAA;EACA,SAAA;AA5BxB;AA+BoB;EACI,6BAAA;EACA,YAAA;EACA,SAAA;EACA,8BAAA;AA7BxB;AAkCoB;EACI,UAAA;EACA,eAAA;AAhCxB;AAmCoB;EACI,QAAA;EACA,SAAA;EACA,eAAA;AAjCxB;AAoCoB;EACI,QAAA;EACA,SAAA;EACA,eAAA;AAlCxB;AAsCoB;EACI,gBAAA;EACA,mBAAA;EACA,eAAA;AApCxB;AAuCoB;EACI,kBAAA;AArCxB;AA6CY;EACI,YAHa;EAIb,gBAJa;EAKb,mBAzJL;EA0JK,gBAAA;AA3ChB;AA6CgB;EACI,gBATS;AAlC7B;AA8CgB;EACI,gBAAA;EACA,2BAAA;AA5CpB;AAkDY;EACI,YAHU;EAIV,gBAJU;EAKV,mBA3KL;AA2HX;AAkDgB;EACI,gBARM;AAxC1B;AAsDY;EACI,YAHc;EAId,gBAJc;AAhD9B;AAsDgB;EACI,gBAPU;AA7C9B;AA0DY;EACI,YAHM;EAIN,mBAjML;AAyIX;AA0DgB;EACI,WAAA;AAxDpB;AA+DY;EACI,YAHU;EAIV,mBA7ML;AAgJX;AA+DgB;EACI,WAAA;AA7DpB;AAoEY;EACI,YAHQ;EAIR,gBAJQ;EAKR,mBA1NL;AAwJX;AAoEgB;EACI,gBARI;AA1DxB;AAyEY;EACI,YAHQ;EAIR,gBAJQ;EAKR,mBAvOL;AAgKX;AAyEgB;EACI,gBARI;AA/DxB;AA0EgB;EACI,WAAA;AAxEpB;AA8EY;EACI,YAHS;EAIT,gBAJS;AAxEzB;AA8EgB;EACI,gBAPK;AArEzB;AAmFY;EACI,YAJS;EAKT,gBALS;EAMT,eAAA;AAjFhB;AAmFgB;EACI,gBATK;AAxEzB;AAoFgB;EACI,WAAA;AAlFpB;AAsFY;EACI,eAAA;AApFhB;AA0FY;EACI,YAHS;EAIT,gBAJS;EAKT,mBAxRL;AAgMX;AA2FgB;EACI,gBATK;AAhFzB;AA4FgB;EACI,WAAA;AA1FpB;AAgGY;EACI,YAHW;EAIX,gBAJW;EAKX,mBAzSL;AA2MX;AAiGgB;EACI,gBATO;AAtF3B;AAkGgB;EACI,WAAA;AAhGpB;AAsGY;EACI,YAHoB;EAIpB,gBAJoB;EAKpB,mBA1TL;EA2TK,cAAA;AApGhB;AAsGgB;EAEI,YAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AArGpB;AAwGgB;EACI,gBAjBgB;AArFpC;AAyGgB;EACI,WAAA;EACA,6BAAA;AAvGpB;AA6GY;EACI,YAAA;EACA,YApVF;EAqVE,gBAAA;EACA,gBAAA;EACA,gBAvVF;EAwVE,iBAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,sBAAA;EACA,6BAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;AA3GhB;AAgHY;EACI,wCAAA;AA9GhB;AAkHQ;EACI,4BAAA;AAhHZ;;AAwHY;EACI,qBAAA;EACA,0BAAA;AArHhB;AAwHY;EACI,mBAAA;EACA,oBAAA;EACA,0BAAA;AAtHhB;AAyHY;EACI,mBAAA;EACA,oBAAA;EACA,0BAAA;AAvHhB;AA2HY;EACI,2BAAA;EACA,8BAAA;EACA,0BAAA;AAzHhB;AA8HY;EACI,6BAAA;AA5HhB;AAiIgB;EACI,qBAAA;AA/HpB;AAoIQ;EACI,uBAAA;AAlIZ;AAyIY;EACI,mBAAA;EACA,0BAAA;AAvIhB;;AA8II;EACI,gBAAA;EACA,mBAAA;EACA,eAAA;AA3IR;AA8II;EACI,kBAAA;AA5IR;;AAmJI;EACI,aAAA;AAhJR;;AAqJA;EACI,WAAA;AAlJJ;;AAqJA;EACI,kBAAA;AAlJJ;AAqJI;EACI,aAAA;AAnJR;AA0JQ;EACI,YAHoB;EAIpB,gBAJoB;EAKpB,mBAhdD;AAwTX;AA2JY;EACI,eAAA;AAzJhB;AA4JY;EACI,gBAbgB;AA7IhC;AA6JY;EACI,gBAAA;EACA,2BAAA;AA3JhB;AAgKQ;EACI,mBAAA;AA9JZ;;AAoLA;EACI,mBAAA;AAjLJ;;AAoLA;EACI,YAAA;AAjLJ;AAmLI;EACI,0BAAA;AAjLR;;AAqLA;EACI,YAAA;AAlLJ;;AAqLA;EACI,YAAA;AAlLJ;;AAuLA;EACI,YAjhBU;AA6Vd;AAsLI;EACI,oBAAA;EACA,6CAAA;AApLR;AAuLI;EACI,WAAA;EACA,6BAAA;AArLR;;AA0LI;EACI,WAAA;EACA,6BAAA;AAvLR;;AA2LA;EACI,qBAAA;AAxLJ;;AA4LA;EACI,gBAAA;EACA,gBAAA;EACA,iBAAA;AAzLJ;;AA4LA;EACI,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EAEA,sBAAA;AA1LJ;AA6LI;EACI,eAAA;AA3LR;AA8LI;EACI,kCAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,yBAAA;UAAA,iBAAA;AA5LR;AA+LI;EACI,aAAA;AA7LR;AAgMI;EACI,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;UAAA,iBAAA;AA9LR;AAiMI;EACI,sBAAA;EACA,sBAAA;AA/LR;AAoMQ;;EACI,kBAAA;AAjMZ;AAoMQ;;EACI,SAAA;EACA,eAAA;AAjMZ;AAoMQ;;EACI,QAAA;EACA,SAAA;EACA,eAAA;AAjMZ;AAoMQ;;EACI,QAAA;EACA,SAAA;EACA,eAAA;AAjMZ;AAqMI;EACI,YAAA;EACA,gBAAA;AAnMR;AAsMI;EACI,2BAAA;AApMR;AAsMQ;EACI,6BAAA;AApMZ;AAyMQ;EACI,uBAAA;AAvMZ;AA2MI;EACI,sBAAA;AAzMR;;AA+MA;EACI,aAAA;EACA,gBAAA;EACA,aAAA;EACA,eAAA;EACA,SAAA;AA5MJ;AA8MI;EACI,gBAAA;EACA,2CAAA;EACA,aAAA;EACA,mBAAA;AA5MR;AA8MQ;EACI,mBAAA;EACA,cAAA;EACA,aAAA;AA5MZ;AA+MQ;EACI,aAAA;EACA,eAAA;AA7MZ;;AAkNA;EACI;IACI,eAAA;EA/MN;EAiNM;IACI,gBAAA;IACA,YAAA;EA/MV;EAiNU;IACI,gBAAA;EA/Md;AACF","sourcesContent":["::-webkit-scrollbar {\n    -webkit-appearance: none;\n    width: 5px;\n    background-color: rgba(122, 122, 122, 0.692);\n}\n\n::-webkit-scrollbar-thumb {\n    border-radius: 7px;\n    background-color: rgba(44, 50, 73, 0.692);\n    box-shadow: 0 0 1px rgba(26, 31, 48, 0.692);\n}\n\n\n.mainDiv {\n    padding-top: 65px;\n}\n\n$cell-heigth: 30px;\n$cell-gap: 17px;\n\n.tableHeader {\n    background-color: aquamarine;\n}\n\n.loadingDataDiv {\n    background-color: transparent;\n    position: absolute;\n    width: 100%;\n    min-height: 500px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    img {\n        width: 100px;\n    }\n}\n\n.clientCreateButtonDiv {\n    width: 100%;\n    position: relative;\n    height: 60px;\n    display: flex;\n    align-items: center;\n\n    .clientCreateButton {\n        margin-left: calc(100vw - 120px);\n        font-size: 14px;\n\n    }\n}\n\n.getMain {\n    overflow-x: scroll;\n\n    div.MuiPaper-rounded {\n        min-height: 100vh;\n        width: 2800px;\n\n    }\n\n    .tableBody {\n        border-radius: 20px;\n\n\n\n        .dataRow {\n            background-color: hsla(0, 0%, 100%, .04);\n\n            .select-box {\n                .gender-select {\n                    div {\n                        padding-top: 5px;\n                        padding-bottom: 5px;\n                    }\n                }\n            }\n\n            .refferal-select {\n                fieldset {\n                    span {\n                        display: none;\n                    }\n                }\n            }\n\n            .select {\n                // height: $cell-heigth;\n\n                label {\n                    color: red;\n                }\n            }\n\n            td {\n                padding: 0;\n                // padding-left: 20px;\n\n                h1 {\n                    margin-left: 10px;\n                    padding: 0 10px;\n                    padding-right: $cell-gap;\n                }\n\n                h3 {\n                    padding-left: 16px;\n                    font-size: 14px;\n                    display: flex;\n                    padding-right: $cell-gap;\n\n                    .summary-input {\n                        background-color: transparent;\n                        color: white;\n                        border: 0;\n                        outline: none;\n                        border-bottom: 1px solid transparent;\n                        width: 65px;\n                        text-align: center;\n                    }\n\n                    .summary-input::-webkit-outer-spin-button,\n                    .summary-input::-webkit-inner-spin-button {\n                        -webkit-appearance: none;\n                        margin: 0;\n                    }\n\n                    .summary-input:focus {\n                        background-color: transparent;\n                        color: white;\n                        border: 0;\n                        border-bottom: 1px solid white;\n                    }\n                }\n\n                div {\n                    label {\n                        top: -11px;\n                        font-size: 14px;\n                    }\n\n                    label.MuiFormLabel-filled {\n                        top: 4px;\n                        left: 4px;\n                        font-size: 12px;\n                    }\n\n                    label.Mui-focused {\n                        top: 4px;\n                        left: 4px;\n                        font-size: 12px;\n                    }\n\n\n                    input {\n                        padding-top: 5px;\n                        padding-bottom: 5px;\n                        font-size: 14px;\n                    }\n\n                    fieldset {\n                        border-radius: 8px;\n                    }\n                }\n\n            }\n\n            $datepicker-box: 130px;\n\n            .datepicker-box {\n                width: $datepicker-box;\n                max-width: $datepicker-box;\n                padding-right: $cell-gap;\n                padding-top: 5px;\n\n                * {\n                    max-width: $datepicker-box;\n                }\n\n                .MuiInputBase-root {\n                    overflow: hidden;\n                    transform: translateY(-3px);\n                }\n            }\n\n            $dogovor-box: 120px;\n\n            .dogovor-box {\n                width: $dogovor-box;\n                max-width: $dogovor-box;\n                padding-right: $cell-gap;\n\n                * {\n                    max-width: $dogovor-box;\n                }\n            }\n\n            $dogovor-box-law: 195px;\n\n            .dogovor-box-law {\n                width: $dogovor-box-law;\n                max-width: $dogovor-box-law;\n\n                * {\n                    max-width: $dogovor-box-law;\n                }\n            }\n\n            $fio-box: 350px;\n\n            .fio-box {\n                width: $fio-box;\n                padding-right: $cell-gap;\n\n                .fio-input {\n                    width: 100%;\n                }\n\n            }\n\n            $company-box: 220px;\n\n            .company-box {\n                width: $company-box;\n                padding-right: $cell-gap;\n\n                .fio-input {\n                    width: 100%;\n                }\n\n            }\n\n            $phone-box: 170px;\n\n            .phone-box {\n                width: $phone-box;\n                max-width: $phone-box;\n                padding-right: $cell-gap;\n\n                * {\n                    max-width: $phone-box;\n                }\n            }\n\n\n            $email-box: 290px;\n\n            .email-box {\n                width: $email-box;\n                max-width: $email-box;\n                padding-right: $cell-gap;\n\n                * {\n                    max-width: $email-box;\n                }\n\n                .email-input {\n                    width: 100%;\n                }\n            }\n\n            $gender-box: 100px;\n\n            .gender-box {\n                width: $gender-box;\n                max-width: $gender-box;\n\n                * {\n                    max-width: $gender-box;\n                }\n            }\n\n            $adress-box: 450px;\n\n\n            .adress-box {\n                width: $adress-box;\n                max-width: $adress-box;\n                padding: 0 $cell-gap;\n\n                * {\n                    max-width: $adress-box;\n                }\n\n                .adress-basic {\n                    width: 100%;\n                }\n            }\n\n            .adress-box-law {\n                padding-left: 0;\n\n            }\n\n            $select-box: 190px;\n\n            .select-box {\n                width: $select-box;\n                max-width: $select-box;\n                padding-right: $cell-gap;\n\n\n                * {\n                    max-width: $select-box;\n                }\n\n                .adress-basic {\n                    width: 100%;\n                }\n            }\n\n            $textarea-box: 210px;\n\n            .textarea-box {\n                width: $textarea-box;\n                max-width: $textarea-box;\n                padding-right: $cell-gap;\n\n\n                * {\n                    max-width: $textarea-box;\n                }\n\n                .adress-basic {\n                    width: 100%;\n                }\n            }\n\n            $datepicker-box-create: 200px;\n\n            .datepicker-box-create {\n                width: $datepicker-box-create;\n                max-width: $datepicker-box-create;\n                padding-right: $cell-gap;\n                padding-top: 0;\n\n                .datetimepicker {\n                    // overflow: hidden;\n                    height: 35px;\n                    padding-top: 0;\n                    min-width: 20px;\n                    margin-top: -4px;\n                }\n\n                * {\n                    max-width: $datepicker-box-create;\n                }\n\n                input.Mui-disabled {\n                    color: #fff;\n                    -webkit-text-fill-color: #fff;\n                }\n            }\n\n\n\n            textarea {\n                width: 200px;\n                height: $cell-heigth;\n                min-width: 200px;\n                max-width: 300px;\n                min-height: $cell-heigth;\n                max-height: 700px;\n                box-sizing: border-box;\n                margin-top: 5px;\n                border-radius: 8px;\n                border: 1px solid gray;\n                background-color: transparent;\n                color: white;\n                padding: 5px;\n                padding-left: 15px;\n            }\n        }\n\n        .dataRow:hover {\n            td {\n                background-color: hsla(0, 0%, 100%, .1);\n            }\n        }\n\n        .tableCell {\n            background-color: aquamarine;\n        }\n    }\n}\n\nbody {\n    .skiny {\n        div {\n            label {\n                top: -11px !important;\n                font-size: 14px !important;\n            }\n\n            label.MuiFormLabel-filled {\n                top: 4px !important;\n                left: 4px !important;\n                font-size: 12px !important;\n            }\n\n            label.Mui-focused {\n                top: 4px !important;\n                left: 4px !important;\n                font-size: 12px !important;\n            }\n\n\n            input {\n                padding-top: 5px !important;\n                padding-bottom: 5px !important;\n                font-size: 14px !important;\n            }\n\n\n\n            fieldset {\n                border-radius: 8px !important;\n            }\n\n            .datetimepicker {\n\n                label {\n                    top: -14px !important;\n                }\n            }\n        }\n\n        .select {\n            height: $cell-heigth !important;\n        }\n\n    }\n\n    .skinyTime {\n        div {\n            label {\n                top: 2px !important;\n                font-size: 14px !important;\n            }\n        }\n    }\n}\n\n.dataRowCreate {\n    td {\n        padding-top: 5px;\n        padding-bottom: 5px;\n        padding-left: 0;\n    }\n\n    td:first-child {\n        padding-left: 20px;\n    }\n\n}\n\n.getMainLaw {\n\n    div.MuiPaper-rounded {\n        width: 2700px;\n\n    }\n}\n\n.getMainCreate::-webkit-scrollbar {\n    height: 5px;\n}\n\n.getMainCreate {\n    overflow-x: scroll;\n\n\n    div.MuiPaper-rounded {\n        width: 2350px;\n\n    }\n\n    .mainTableCreate {\n        $datepicker-box-create: 200px;\n\n        .datepicker-box-create {\n            width: $datepicker-box-create;\n            max-width: $datepicker-box-create;\n            padding-right: $cell-gap;\n            // padding-top: 14px;\n\n            div.MuiTextField-root {\n                min-width: 20px;\n            }\n\n            * {\n                max-width: $datepicker-box-create;\n            }\n\n            .MuiInputBase-root {\n                overflow: hidden;\n                transform: translateY(-3px);\n            }\n        }\n\n\n        .tableBody .dataRow td div fieldset {\n            border-radius: 10px;\n        }\n    }\n}\n\n// .getMainCreateLaw {\n//     overflow-x: hidden;\n\n//     div.MuiPaper-rounded {\n//         width: 100%;\n//         min-width: 1700px;\n//     }\n\n//     .mainTableCreate {\n//         .datepicker-box-create {\n//             // width: auto;\n//             // max-width: auto;\n\n//         }\n//     }\n// }\n\n.MuiInputBase-formControl fieldset {\n    border-radius: 10px;\n}\n\n.refferal-select {\n    width: 170px;\n\n    .MuiSelect-select {\n        font-size: 14px !important;\n    }\n}\n\n.location-select {\n    width: 170px;\n}\n\n.gender-select {\n    width: 100px;\n}\n\n\n\n.select-box {\n    height: $cell-heigth;\n\n    label {\n        margin-bottom: -25px;\n        transform: translateY(-20px) translateX(10px);\n    }\n\n    .MuiOutlinedInput-input.Mui-disabled {\n        color: #fff;\n        -webkit-text-fill-color: #fff;\n    }\n}\n\n.gender-select {\n    .MuiOutlinedInput-input.Mui-disabled {\n        color: #fff;\n        -webkit-text-fill-color: #fff;\n    }\n}\n\n.AccordionDetails {\n    padding: 0 !important;\n}\n\n\n.accordionHeaders {\n    margin-bottom: 0;\n    margin-top: 10px;\n    margin-left: 15px;\n}\n\n.filtrDiv {\n    padding: 10px 15px;\n    padding-top: 5px;\n    display: flex;\n    align-items: center;\n    gap: 30px;\n    // height: 50px;\n    box-sizing: border-box;\n\n\n    .searchInput {\n        margin-top: 8px;\n    }\n\n    .createClientTypograpyh {\n        border: 2px solid rgb(26, 213, 26);\n        border-radius: 10px;\n        padding: 10px 15px;\n        cursor: pointer;\n        margin-top: 8px;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        max-height: 43px;\n        height: 43px;\n        user-select: none;\n    }\n\n    .createTaskTypograpyh {\n        margin-top: 0;\n    }\n\n    .statisticButton {\n        border: 1px solid #525252;\n        border-radius: 10px;\n        padding: 10px 15px;\n        cursor: pointer;\n        margin-top: 8px;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        max-height: 41px;\n        user-select: none;\n    }\n\n    .statisticButton:hover {\n        border: 1px solid #fff;\n        color: #fff !important;\n    }\n\n    .datetimepicker,\n    .searchInput {\n        input {\n            padding: 10px 20px;\n        }\n\n        label {\n            top: -5px;\n            font-size: 14px;\n        }\n\n        label.MuiFormLabel-filled {\n            top: 4px;\n            left: 4px;\n            font-size: 12px;\n        }\n\n        label.Mui-focused {\n            top: 4px;\n            left: 4px;\n            font-size: 12px;\n        }\n    }\n\n    .datetimepicker {\n        height: 40px;\n        max-width: 100px;\n    }\n\n    .dateFromTo {\n        min-width: 190px !important;\n\n        input {\n            color: transparent !important;\n        }\n    }\n\n    .dateValue {\n        input {\n            color: white !important;\n        }\n    }\n\n    p {\n        color: gray !important;\n    }\n\n\n}\n\n.statisticDiv {\n    padding: 15px;\n    padding-top: 0px;\n    display: flex;\n    flex-wrap: wrap;\n    gap: 20px;\n\n    .statBlock {\n        min-width: 100px;\n        background-color: rgba(255, 255, 255, 0.07);\n        padding: 20px;\n        border-radius: 10px;\n\n        h4 {\n            margin-bottom: 10px;\n            color: #1976d2;\n            margin-top: 0;\n        }\n\n        p {\n            margin: 5px 0;\n            font-size: 14px;\n        }\n    }\n}\n\n@media (max-width: 1750px) {\n    .filtrDiv {\n        flex-wrap: wrap;\n\n        .datetimepicker {\n            overflow: hidden;\n            height: 43px;\n\n            * {\n                overflow: hidden;\n            }\n        }\n    }\n}\n\n@media (max-width: 1650px) {\n    .filtrDiv {}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
